/*
 * Page contact : pastilles de motif, champ de précision, pré-remplissage par lien,
 * validation en français et bouton Copier.
 *
 * Sans ce script, le formulaire reste un formulaire Shopify ordinaire : motifs
 * cochables, champs obligatoires vérifiés par le navigateur. Le script ajoute
 * le champ qui suit le motif, les messages d'erreur sous chaque champ et le
 * rappel de l'envoi sur l'écran de confirmation.
 *
 * Liens reconnus : /pages/contact?motif=<identifiant du motif>&produit=<nom>.
 * Un bouton ou un lien portant data-ctc-choisir="<identifiant>" (questions
 * fréquentes) coche le motif sur place quand le formulaire est sur la page.
 */

(function () {
  'use strict';

  if (customElements.get('contact-sobrerie')) return;

  var CLE_ENVOI = 'sobrerie-contact-envoi';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function reduire() {
    return typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Le stockage peut être refusé (navigation privée, cookies bloqués) : sans
     lui, la confirmation s'affiche simplement sans le rappel. */
  function lireEnvoi() {
    try { return JSON.parse(window.sessionStorage.getItem(CLE_ENVOI) || 'null'); } catch (e) { return null; }
  }
  function ecrireEnvoi(valeur) {
    try {
      if (valeur) window.sessionStorage.setItem(CLE_ENVOI, JSON.stringify(valeur));
      else window.sessionStorage.removeItem(CLE_ENVOI);
    } catch (e) { /* rien à faire */ }
  }

  function minusculeInitiale(texte) {
    return texte ? texte.charAt(0).toLowerCase() + texte.slice(1) : texte;
  }

  class ContactSobrerie extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ctcPret === 'oui') return;
      this.dataset.ctcPret = 'oui';

      this.carte = this.querySelector('[data-ctc-carte]');
      this.lierCopie();
      this.lierBoutique();

      var merci = this.querySelector('[data-ctc-merci]');
      if (merci) {
        this.afficherRappel(merci);
        return;
      }

      this.form = this.querySelector('.ctc-form');
      if (!this.form || !this.querySelector('[data-ctc-champs]')) return;

      this.motifs = Array.prototype.slice.call(this.querySelectorAll('input[data-ctc-motif]'));
      this.precision = this.querySelector('[data-ctc-precision]');
      this.precisionLibelle = this.querySelector('[data-ctc-precision-libelle]');
      this.precisionChamp = this.precision ? this.precision.querySelector('input') : null;
      this.message = this.querySelector('[data-ctc-message]');
      this.messageExemple = this.message ? this.message.getAttribute('placeholder') : '';
      this.requis = Array.prototype.slice.call(this.querySelectorAll('[data-ctc-requis]'));

      this.form.noValidate = true;
      this.form.addEventListener('change', this.surChangement.bind(this));
      this.form.addEventListener('submit', this.surEnvoi.bind(this));
      this.requis.forEach(function (champ) {
        champ.addEventListener('input', function () { this.montrerErreur(champ, ''); }.bind(this));
      }, this);

      /* Retour arrière du navigateur : un motif déjà coché retrouve son champ. */
      var coche = this.motifCoche();
      if (coche) this.appliquerMotif(coche, true);

      this.lireLien();
    }

    motifCoche() {
      for (var i = 0; i < this.motifs.length; i++) {
        if (this.motifs[i].checked) return this.motifs[i];
      }
      return null;
    }

    trouverMotif(cle) {
      if (!cle) return null;
      for (var i = 0; i < this.motifs.length; i++) {
        if (this.motifs[i].dataset.cle === cle) return this.motifs[i];
      }
      return null;
    }

    surChangement(evenement) {
      if (evenement.target.matches('input[data-ctc-motif]')) this.appliquerMotif(evenement.target, false);
    }

    appliquerMotif(radio, garderPrecision) {
      if (this.message) {
        this.message.placeholder = (radio && radio.dataset.message) || this.messageExemple;
      }
      if (!this.precision || !this.precisionChamp) return;

      var libelle = radio ? radio.dataset.precision : '';
      if (!garderPrecision) this.precisionChamp.value = '';

      if (libelle) {
        var etaitCache = this.precision.hidden;
        this.precisionLibelle.textContent = libelle;
        this.precisionChamp.placeholder = radio.dataset.exemple || '';
        /* Le nom du champ devient son libellé : c'est ce que l'équipe lit dans l'email. */
        this.precisionChamp.name = 'contact[' + libelle + ']';
        this.precisionChamp.disabled = false;
        this.precision.hidden = false;
        if (etaitCache && !reduire()) {
          this.precision.classList.remove('ctc-champ--apparait');
          void this.precision.offsetWidth;
          this.precision.classList.add('ctc-champ--apparait');
        }
      } else {
        this.precisionChamp.disabled = true;
        this.precision.hidden = true;
      }
    }

    choisir(cle, precision) {
      var radio = this.trouverMotif(cle);
      if (!radio) return false;
      radio.checked = true;
      this.appliquerMotif(radio, false);
      if (precision && radio.dataset.precision && this.precisionChamp) this.precisionChamp.value = precision;
      return true;
    }

    lireLien() {
      var params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      var cle = params.get('motif');
      var produit = params.get('produit');
      if (!cle && !produit) return;

      if (cle && this.choisir(cle, produit)) return;
      if (produit) {
        for (var i = 0; i < this.motifs.length; i++) {
          if (this.motifs[i].dataset.produit === 'true') {
            this.choisir(this.motifs[i].dataset.cle, produit);
            return;
          }
        }
      }
    }

    defiler() {
      if (this.carte) this.carte.scrollIntoView({ behavior: reduire() ? 'auto' : 'smooth', block: 'start' });
    }

    montrerErreur(champ, texte) {
      var id = champ.id + '-erreur';
      var zone = document.getElementById(id);
      if (zone) {
        zone.textContent = texte;
        zone.hidden = !texte;
      }
      if (texte) champ.setAttribute('aria-invalid', 'true');
      else champ.removeAttribute('aria-invalid');
    }

    verifier(champ) {
      var valeur = (champ.value || '').trim();
      if (!valeur) return champ.dataset.ctcRequis || '';
      if (champ.type === 'email' && !EMAIL.test(valeur)) return champ.dataset.ctcFormat || '';
      return '';
    }

    surEnvoi(evenement) {
      var premier = null;
      this.requis.forEach(function (champ) {
        var texte = this.verifier(champ);
        this.montrerErreur(champ, texte);
        if (texte && !premier) premier = champ;
      }, this);

      if (premier) {
        evenement.preventDefault();
        premier.focus();
        return;
      }

      var email = this.form.querySelector('input[type="email"]');
      var coche = this.motifCoche();
      ecrireEnvoi({
        email: email ? email.value.trim() : '',
        motif: coche ? coche.value : ''
      });
    }

    /* Écran de confirmation : rappel de l'adresse et du motif, lus une seule fois. */
    afficherRappel(merci) {
      var envoi = lireEnvoi();
      ecrireEnvoi(null);
      var rappel = merci.querySelector('[data-ctc-recap]');
      if (rappel && envoi && envoi.email) {
        var texte = 'Envoyé depuis ' + envoi.email;
        if (envoi.motif) texte += ', à propos de : ' + minusculeInitiale(envoi.motif);
        rappel.textContent = texte + '.';
        rappel.hidden = false;
      }
      merci.focus({ preventScroll: true });
    }

    lierCopie() {
      this.querySelectorAll('[data-ctc-copier]').forEach(function (bouton) {
        var libelle = bouton.textContent;
        var minuterie = null;

        function annoncer(texte) {
          bouton.textContent = texte;
          window.clearTimeout(minuterie);
          minuterie = window.setTimeout(function () { bouton.textContent = libelle; }, 2200);
        }

        function selectionner() {
          var valeur = bouton.closest('.ctc-canal').querySelector('[data-ctc-valeur]');
          if (!valeur || !window.getSelection) return;
          var plage = document.createRange();
          plage.selectNodeContents(valeur);
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(plage);
          annoncer(bouton.dataset.ctcSelection || libelle);
        }

        bouton.addEventListener('click', function () {
          var texte = bouton.dataset.ctcCopier;
          if (!navigator.clipboard || !navigator.clipboard.writeText) {
            selectionner();
            return;
          }
          navigator.clipboard.writeText(texte).then(function () {
            annoncer(bouton.dataset.ctcCopie || libelle);
          }, selectionner);
        });
      });
    }

    /* « Voir la boutique » : #boutique descend jusqu'à la section Boutique physique,
       dont l'identifiant n'est pas connu à l'avance. */
    lierBoutique() {
      var lien = this.querySelector('[data-ctc-vers-boutique]');
      if (!lien) return;
      lien.addEventListener('click', function (evenement) {
        var href = lien.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var cible = document.getElementById(href.slice(1)) || document.querySelector('.store-visit');
        if (!cible) return;
        evenement.preventDefault();
        cible.scrollIntoView({ behavior: reduire() ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  customElements.define('contact-sobrerie', ContactSobrerie);

  /* Questions fréquentes : coche le motif sur place au lieu de recharger la page. */
  document.addEventListener('click', function (evenement) {
    var declencheur = evenement.target.closest('[data-ctc-choisir]');
    if (!declencheur) return;
    if (evenement.button !== 0 || evenement.metaKey || evenement.ctrlKey || evenement.shiftKey || evenement.altKey) return;
    var contact = document.querySelector('contact-sobrerie');
    if (!contact || !contact.form || !contact.choisir) return;
    if (!contact.choisir(declencheur.getAttribute('data-ctc-choisir'))) return;
    evenement.preventDefault();
    contact.defiler();
  });
})();
